module.exports = __webpack_public_path__ + "img/hdjjTitleBg1.df55a802.png";